import Module from "@/modules/auth/Module";
import Login from "@/modules/auth/views/Login";
import store from "@/store";

export default {
    path: "/login",
    component: Module,
    beforeEnter: (to, from, next) => {
        if (store.getters["auth/isAuthorized"]) {
            return next('/profile');
        }
        return next();
    },
    children: [
        {
            path: "",
            component: Login,
            meta: {
                title: 'Вход'
            }
        }
    ]
};